import { useSelector } from "react-redux";
import { RootState } from "../../../../../stores/store";
import styles from "./progress-page.module.scss";
import moment from "moment";

export const ProgressPage = () => {
    const recommendationDetails = useSelector((state: RootState) => state.getSolar.recommendationDetails);

    return (
        <div className={styles.container}>
            {recommendationDetails?.events.map((item, id) => (
                <div key={id} className={styles.progressItem}>
                    <div className={styles.progressLeft}>
                        <span className={styles.dot} />
                        <div className={styles.progressTextWrapper}>
                            <span className={styles.progressText}>{item.eventTitle}</span>
                            {item.eventDescription && (
                                <span className={styles.progressDescription}>{item.eventDescription}</span>
                            )}
                        </div>
                    </div>
                    <div className={styles.progressDateTime}>
                        <span className={styles.progressTime}>{moment(item.timestamp).format("h:mm A")}</span>
                        <span className={styles.progressDate}>{moment(item.timestamp).format("Do MMM, YYYY")}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};
